import { withNamespaces } from "react-i18next";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from "reactstrap";

const DDSSubmitConfirmModal = ({ t, isOpen, toggle, onConfirm, isFormSubmiting }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>
                {t('Confirm DDS Submission')}
            </ModalHeader>
            <ModalBody>
                <p className="mb-2">
                    {t('You are about to submit your Due Diligence Statement (DDS).')}
                </p>
                <p className="text-muted mb-0">
                    {t('Once submitted, your DDS will be validated and locked for further edits.')}
                    {t('Please make sure all product details are complete and accurate before continuing.')}
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    {t('Cancel')}
                </Button>
                <Button 
                    color="primary" 
                    onClick={onConfirm}
                    disabled={isFormSubmiting}
                >
                    {isFormSubmiting ? (
                        <>
                            <Spinner
                                size='sm'
                                color="white"
                                className="me-2"
                            />
                            {t('Submitting')}
                        </>
                    ) : (
                        <>{t('Submit DDS')}</>
                    )}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    DDSSubmitConfirmModal
);
